import { QueryFunctionContext, useQuery } from '@tanstack/react-query'
import { getApiClient } from '../../../shared/types/api-client'
import { AppSetting } from '../types/AppSetting'

const SCOPE = 'configuration'
const LIST = 'list'

const keysFactory = {
  all: () => [{ scope: SCOPE }] as const,
  list: (appId: string) => [{ scope: SCOPE, entity: LIST, appId }] as const,
}

const getConfiguration = async ({
  queryKey: [{ appId }],
}: QueryFunctionContext<ReturnType<(typeof keysFactory)['list']>>) => {
  const apiClient = getApiClient()
  const response = await apiClient.get(`FunctionApps/${encodeURIComponent(appId)}/Configuration`)
  return response.data as AppSetting[]
}

export function useFunctionAppConfiguration(appId: string | null): [AppSetting[], boolean] {
  const { isFetching, data } = useQuery({
    queryKey: [...keysFactory.list(appId ?? '')],
    queryFn: getConfiguration,
    placeholderData: [],
    enabled: !!appId,
  })
  return [data ?? [], isFetching]
}
